var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDeployment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_536",
    "data-name": "Group 536",
    transform: "translate(-4813 -1682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_535",
    "data-name": "Group 535"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M4823.218,1687.375a.48.48,0,0,1,0-.676l1.443-1.442a.481.481,0,0,1,.68,0l1.442,1.442a.481.481,0,1,1-.68.68l-.621-.622v3.176a.481.481,0,0,1-.962,0v-3.176l-.622.622A.48.48,0,0,1,4823.218,1687.375Zm2.88,13.246-.621.622v-3.176a.481.481,0,0,0-.962,0v3.176l-.622-.622a.481.481,0,0,0-.68.68l1.443,1.442a.481.481,0,0,0,.68,0l1.442-1.442a.481.481,0,0,0-.68-.68Z",
    fill: "#18c99d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M4818.371,1692.231a.481.481,0,0,1-.587-.334l-.528-1.971a.479.479,0,0,1,.34-.588l1.97-.528a.48.48,0,1,1,.249.928l-.849.228,2.75,1.588a.481.481,0,1,1-.481.833l-2.75-1.588.228.849A.482.482,0,0,1,4818.371,1692.231Zm12.912,4.129.228.849-2.751-1.588a.481.481,0,0,0-.481.832l2.751,1.589-.849.227a.481.481,0,0,0,.248.929l1.971-.528a.482.482,0,0,0,.34-.589l-.528-1.97a.481.481,0,0,0-.929.249Z",
    fill: "#18c99d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M4820.153,1698.856a.479.479,0,0,1-.582.342l-1.971-.528a.48.48,0,0,1-.34-.589l.528-1.97a.481.481,0,1,1,.929.249l-.228.849,2.751-1.588a.481.481,0,0,1,.481.833l-2.751,1.588.849.227A.478.478,0,0,1,4820.153,1698.856Zm10.032-9.118.849.228-2.751,1.588a.481.481,0,0,0,.481.833l2.751-1.588-.228.849a.481.481,0,0,0,.929.249l.528-1.971a.479.479,0,0,0-.34-.588l-1.97-.528a.48.48,0,0,0-.249.928Z",
    fill: "#18c99d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_72",
    "data-name": "Ellipse 72",
    cx: 1.496,
    cy: 1.496,
    r: 1.496,
    transform: "translate(4823.504 1692.504)",
    fill: "#18c99d"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_205",
    "data-name": "Rectangle 205",
    width: 24,
    height: 24,
    transform: "translate(4813 1682)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeployment);
export default __webpack_public_path__ + "static/media/icon-deployment.b5dcc841f8ea01c21d5d555959c35493.svg";
export { ForwardRef as ReactComponent };